import {FilterType} from '/enum/filterType.enum';

import {TabFilters} from '../../types/MyTeamsFilters.types';
import {BONUS_OPTIONS} from '../constants/bonusOptions.constant';

import {buildFIBCItems} from './buildFIBCOptions.util';
import {buildNewCoachesOptions} from './buildNewCoachesOptions.util';
import {buildDefaultRankItems} from './buildRankOptions.util';

export const buildDefaultFilters = (
  optionSelected: (id: string, type: FilterType) => void,
  ffTeamsOrgSR: boolean,
  reportHeading: string,
  defaultFrontlineOnly: boolean,
): TabFilters => {
  const rankItems = buildDefaultRankItems(optionSelected);

  return {
    rankOptions: rankItems,
    newCoachesOptions: buildNewCoachesOptions({
      ffTeamsOrgSR,
      reportHeading,
      onSelect: id => optionSelected(id, FilterType.NEW_COACHES),
    }),
    fibcOptions: buildFIBCItems(id => optionSelected(id, FilterType.FIBC)),
    bonusOptions: BONUS_OPTIONS.map(item => ({
      ...item,
      selected: false,
    })),
    frontlineOnly: defaultFrontlineOnly,
    closeToNextRank: false,
    bonusWithoutFilter: undefined,
    rankWithoutFilter: undefined,
    newCoachesWithoutFilter: undefined,
    fibcWithoutFilter: undefined,
    fqvWithoutFilter: null,
    filterRangeWithoutFilter: null,
    newCoachesSponsoredWithoutFilter: null,
    showAllFilters: false,
  };
};
